import BookingFormView from './BookingFormView';

export default BookingFormView;
